import { createSlice } from '@reduxjs/toolkit'
import {
  notificationActionHistoryResetAlertHandler,
  getNotificationActionHistoryList,
} from './notificationActionHistoryThunk'
import { updateStateFromQueries } from '../../../../utils/helpers'

const defaultPageSize = 9
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortList: [],
  activeSort: {},
  filterList: [],
  activeFilters: {},
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  finalPage: true,
}

const notificationActionHistorySlice = createSlice({
  name: 'notificationActionHistory',
  initialState,

  extraReducers: (builder) => {
    builder.addCase(notificationActionHistoryResetAlertHandler.fulfilled, (state) => {
      state.alert = {}
    });

    builder.addCase(
      getNotificationActionHistoryList.pending,
      (state, { meta: { arg: { queries } } }) => {
        state.loading.fetch = true
        state.alert = {}
        state.pageNumber = queries?.pageNumber ? queries?.pageNumber : 0
        if (!queries?.pageNumber) {
          state.data = []
        }
      },
    );

    builder.addCase(getNotificationActionHistoryList.rejected, (state, { payload }) => {
      state.loading.fetch = false
      state.alert = payload
    });

    builder.addCase(getNotificationActionHistoryList.fulfilled, (state, { payload }) => {
      const { response, queries } = payload
      state.data = queries?.pageNumber === 0 ? response.data : [...state.data, ...response.data]
      state.summaries.all = response.data.length
      state.finalPage = response.data.length < state.pageSize
      state.loading.fetch = false
      state.alert = {}
      updateStateFromQueries(state, queries)
    });
  },
})

export const selectNotificationActionHistory =
({ notificationActionHistory }) => notificationActionHistory

export default notificationActionHistorySlice.reducer
